module.exports = __webpack_public_path__ + "static/media/exit_full_screen.c8223a6a.svg";